module.exports = ".sidebar {\n  width: 38px;\n  height: 100%;\n  color: #ffffff;\n  background-color: #000f25;\n  overflow: hidden; }\n  .sidebar.expanded {\n    width: 150px; }\n  .sidebar .sidebar-logo-container {\n    text-align: center; }\n  .sidebar .sidebar-logo-container .nav-logo {\n      margin: 20px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/sidebar/sidebar.component.scss
// module id = ./src/app/shared/sidebar/sidebar.component.scss
// module chunks = main